<template>
  <div class="business-statement">
    <el-form class="form" :model="query" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="公司" prop="companyCode">
            <el-select v-model="companyCode" style="width: 100%" clearable @change="getDepartment">
              <el-option
                v-for="(item, index) in companyList"
                :label="item.label"
                :value="item.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="部门" prop="contractBusinessDepartment">
            <el-select
              v-model="departmentCode"
              style="width: 100%"
              clearable
              @change="resetProject"
            >
              <el-option
                v-for="(item, index) in departmentList"
                :label="item.personDepartmentName"
                :value="item.personDepartmentCode"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="项目" required>
            <SearchTable
              ref="projectRef"
              v-model="query.projectInitiationNo"
              searchType="projectListWumaoByPage"
              :isMultiple="true"
              :currentValue="query.projectName ? query.projectName : ''"
              :checkRowKeys="query.projectInitiationNo ? [query.projectInitiationNo] : []"
              :extraData="{
                // applyDepartmentName: userInfo.departmentName,
                projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
                //platformtCompanyList: [userInfo.companyCode],
                // // applyDepartmentNo: userInfo.departmentCode,
                // businessGroup: userInfo.businessGroup,
                // applyDepartmentNo: userInfo.departmentCode,
                applyDepartmentNoList: departmentCode
                  ? [departmentCode]
                  : (userInfo.allDepartmentList || []).map((v) => v.personDepartmentCode),
                // platformtCompany: userInfo.companyCode,
                // platformtCompanyName: userInfo.companyName,
                // applyCompanyNo: userInfo.companyCode,
                // applyCompanyName: userInfo.companyName,
              }"
              @input="(val) => chooseForm(val, 'projectInitiationNo')"
            ></SearchTable>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="采购合同">
            <!-- <el-input v-model="query.purchaseContractNoLike" /> -->
            <SearchTable
              ref="purchaseContractRef"
              v-model="query.purchaseContractNoList"
              searchType="saleContract"
              :isMultiple="false"
              :currentValue="purchaseContractNoLike ? purchaseContractNoLike : ''"
              :checkRowKeys="
                query.purchaseContractNoList.length ? query.purchaseContractNoList : []
              "
              :extraData="{
                applyDepartmentNo: userInfo.departmentCode,
                applyDepartmentName: userInfo.departmentName,
                contractCategory: 'purchase',
                projectInitiationNo: query.projectInitiationNo,
              }"
              @input="(val) => chooseForm(val, 'purchaseContractNoLike')"
            ></SearchTable>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="销售合同">
            <!-- <el-input v-model="query.salesContractNoLike" /> -->
            <SearchTable
              ref="salesContractRef"
              v-model="query.saleContractNoList"
              searchType="saleContract"
              :isMultiple="false"
              :currentValue="salesContractNoLike ? salesContractNoLike : ''"
              :checkRowKeys="query.saleContractNoList.length ? query.saleContractNoList : []"
              :extraData="{
                applyDepartmentNo: userInfo.departmentCode,
                applyDepartmentName: userInfo.departmentName,
                contractCategory: 'sales',
                projectInitiationNo: query.projectInitiationNo,
              }"
              @input="(val) => chooseForm(val, 'salesContractNoLike')"
            ></SearchTable>
          </el-form-item>
        </el-col>
        <el-col :span="10" :offset="8" class="text-right">
          <el-button type="primary" @click="initTableData">搜索</el-button>
          <el-button type="primary" @click="resetClick">重置</el-button>
          <el-button
            v-for="item in menuButtonList"
            :key="item.id"
            type="primary"
            @click="clickMenuButton(item.attributes)"
          >
            {{ item.label }}
          </el-button>
          <!-- <el-button type="primary">导出EXCEL</el-button> -->
        </el-col>
      </el-row>
    </el-form>
    <div v-for="(item, index) of tableData1" :key="index">
      <h3>上游业务信息</h3>
      <vxe-grid
        keep-source
        style="margin-top: 10px"
        border
        size="mini"
        align="left"
        show-overflow
        show-header-overflow
        ref="xTableRef"
        class="vxe-table-element"
        resizable
        show-footer
        :span-method="rowspanMethod"
        :auto-resize="true"
        :data="item"
        :columns="tableColumnsList1"
        :valid-config="{ autoPos: true, message: 'inline' }"
        max-height="400"
        :footer-method="footerMethod1"
      ></vxe-grid>
      <div style="margin: 30px 0"></div>
    </div>

    <div v-for="(item, index) of tableData2" :key="index">
      <h3>下游业务信息</h3>
      <vxe-grid
        style="margin-top: 10px"
        keep-source
        border
        size="mini"
        align="left"
        show-overflow
        show-header-overflow
        ref="xTableRef"
        class="vxe-table-element"
        resizable
        show-footer
        :auto-resize="true"
        :data="item"
        :span-method="rowspanMethod"
        :columns="tableColumnsList2"
        :footer-method="footerMethod2"
        :valid-config="{ autoPos: true, message: 'inline' }"
        max-height="400"
      ></vxe-grid>
    </div>
  </div>
</template>

<script>
  import mixins from './index.js';
  import { getUserCompanyList } from '@/common/js/util';
  import API from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  export default {
    name: 'businessStatement',
    mixins: [mixins],
    data() {
      return {
        tableData1: [],
        tableData2: [],
        query: {
          projectInitiationNo: '',
          projectName: '',
          purchaseContractNoList: [],
          saleContractNoList: [],
        },
        companyCode: null,
        departmentCode: null,
        companyList: [],
        departmentList: [],
        menuButtonList: [],
      };
    },
    computed: {
      purchaseContractNoLike() {
        if (this.query.purchaseContractNoList && this.query.purchaseContractNoList.length != 0) {
          return this.query.purchaseContractNoList.join(',');
        }
        return '';
      },
      salesContractNoLike() {
        if (this.query.saleContractNoList && this.query.saleContractNoList.length != 0) {
          return this.query.saleContractNoList.join(',');
        }
        return '';
      },
    },
    async mounted() {
      this.getButtonList();
      this.companyList = await getUserCompanyList();
    },
    // activated() {
    //   if (!this.query.projectInitiationNo) {
    //     this.$message.warning('请选择项目');
    //   }
    // },
    methods: {
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      clickMenuButton(menuInfo) {
        this[menuInfo.buttonUrl]();
      },
      refreshData() {
        if (!this.query.purchaseContractNoList.length && !this.query.saleContractNoList.length) {
          return this.$message.error('请先选择采购合同或销售合同');
        }
        const tips = `是否需要刷新${
          this.purchaseContractNoLike ? '“合同' + this.purchaseContractNoLike + '”' : ''
        }${this.purchaseContractNoLike && this.salesContractNoLike ? '、' : ''}${
          this.salesContractNoLike ? '“合同' + this.salesContractNoLike + '”' : ''
        }的业务明细数据？`;
        let list = [...this.query.purchaseContractNoList, ...this.query.saleContractNoList];
        // if (this.query.purchaseContractNoLike) list.push(this.query.purchaseContractNoLike);
        // if (this.query.salesContractNoLike) list.push(this.query.salesContractNoLike);
        this.$confirm(tips, '提示', {
          type: 'warning',
        }).then(() => {
          this.$axios.post('/financial/statistic/businessDetail/execBusinessDetailData', list, {
            contentType: 'application/json',
          });
          this.$message({ showClose: true, message: '刷新成功', type: 'success' });
          this.initTableData();
        });
      },
      // 重置按钮
      resetClick() {
        if (this.$refs.projectRef) {
          this.$refs.projectRef.resetClick();
        }
        if (this.$refs.purchaseContractRef) {
          this.$refs.purchaseContractRef.resetClick();
        }
        if (this.$refs.salesContractRef) {
          this.$refs.salesContractRef.resetClick();
        }
        (this.query = {
          projectInitiationNo: '',
          purchaseContractNoList: [],
          saleContractNoList: [],
        }),
          (this.tableData1 = []),
          (this.tableData2 = []),
          this.$nextTick(() => {
            this.$forceUpdate();
            this.initTableData();
          });
      },
      // 导出按钮
      async exportExcel() {
        let params = { ...this.query };
        if (params.saleContractNoList && !params.saleContractNoList.length) {
          delete params.saleContractNoList;
        } else {
          params.saleContractNoList = params.saleContractNoList.toString();
        }
        if (params.purchaseContractNoList && !params.purchaseContractNoList.length) {
          delete params.purchaseContractNoList;
        } else {
          params.purchaseContractNoList = params.purchaseContractNoList.toString();
        }
        params = XEUtils.serialize({
          ...params,
          pageSize: 10,
          pageNum: 1,
        });
        window.open(
          `${this.baseUrl}/financial/statistic/businessDetail/exportV2?${params}&access_token=${this.userInfo.access_token}`,
          '_blank'
        );
      },
      chooseForm(val, type) {
        const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
        console.log(rowData);
        if (type == 'projectInitiationNo') {
          console.log(val);
          this.query.projectInitiationNo = rowData.projectInitiationNo;
          this.query.projectName = rowData.projectName;
          this.query.purchaseContractNoList = [];
          this.query.saleContractNoList = [];
        } else if (type == 'purchaseContractNoLike') {
          if (val && Array.isArray(val) && val.length) {
            this.query.purchaseContractNoList = val
              ?.filter((item) => item.contractNo)
              .map((item) => item.contractNo);
          } else {
            this.query.purchaseContractNoList = [];
          }
        } else if (type == 'salesContractNoLike') {
          if (val && Array.isArray(val) && val.length) {
            this.query.saleContractNoList = val
              ?.filter((item) => item.contractNo)
              .map((item) => item.contractNo);
          } else {
            this.query.saleContractNoList = [];
          }
        }
      },
      //合并
      rowspanMethod({ column, row, data, rowIndex }) {
        const fields = ['supplierName', 'customerName'];
        const cellValue = row[column.property];
        if (cellValue && fields.includes(column.property)) {
          const prevRow = data[rowIndex - 1];
          let nextRow = data[rowIndex + 1];
          if (prevRow && prevRow[column.property] === cellValue) {
            return { rowspan: 0, colspan: 0 };
          } else {
            let countRowspan = 1;
            while (nextRow && nextRow[column.property] === cellValue) {
              nextRow = data[++countRowspan + rowIndex];
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 };
            }
          }
        }
      },
      formatTableData1(item) {
        const tableData = [];
        // 获取list中里面最长的一个节点
        const payableSettlementInfoList = item.payableSettlementInfoList;
        // const paymentInfoList = item.paymentInfoList;
        const payableInvoiceInfoList = item.payableInvoiceInfoList;
        const len1 = payableSettlementInfoList?.length ? payableSettlementInfoList?.length : 0;
        // const len2 = paymentInfoList?.length ? paymentInfoList?.length : 0;
        const len3 = payableInvoiceInfoList?.length ? payableInvoiceInfoList?.length : 0;
        const max = Math.max(len1, len3);
        if (max) {
          for (let i = 0; i < max; i++) {
            const obj = {
              settlementNo:
                payableSettlementInfoList && i < payableSettlementInfoList.length
                  ? payableSettlementInfoList[i]?.settlementNo
                  : null,
              periodRange:
                payableSettlementInfoList && i < payableSettlementInfoList.length
                  ? payableSettlementInfoList[i]?.periodRange
                  : null,
              settlementDate:
                payableSettlementInfoList && i < payableSettlementInfoList.length
                  ? payableSettlementInfoList[i]?.settlementDate
                  : null,
              settlementType:
                payableSettlementInfoList && i < payableSettlementInfoList.length
                  ? payableSettlementInfoList[i]?.settlementType
                  : null,
              settlementQuantity:
                payableSettlementInfoList && i < payableSettlementInfoList.length
                  ? payableSettlementInfoList[i]?.settlementQuantity
                  : null,
              settlementAmount:
                i < payableSettlementInfoList.length
                  ? payableSettlementInfoList[i]?.settlementAmount
                  : null,
              preSettlementQuantity:
                payableSettlementInfoList && i < payableSettlementInfoList.length
                  ? payableSettlementInfoList[i]?.preSettlementQuantity
                  : null,
              preSettlementAmount:
                i < payableSettlementInfoList.length
                  ? payableSettlementInfoList[i]?.preSettlementAmount
                  : null,
              finalSettlementQuantity:
                payableSettlementInfoList && i < payableSettlementInfoList.length
                  ? payableSettlementInfoList[i]?.finalSettlementQuantity
                  : null,
              finalSettlementAmount:
                payableSettlementInfoList && i < payableSettlementInfoList.length
                  ? payableSettlementInfoList[i]?.finalSettlementAmount
                  : null,
              // finalSettlementHopeTotalAmount:
              //   payableSettlementInfoList && i <= payableSettlementInfoList.length
              //     ? payableSettlementInfoList[i]?.finalSettlementHopeTotalAmount
              //     : null,
              // paymentApplyRequestAmount:
              //   payableSettlementInfoList && i <= payableSettlementInfoList.length
              //     ? payableSettlementInfoList[i]?.rateAmount
              //     : null,
              // paymentApplyRate:
              //   payableSettlementInfoList && i <= payableSettlementInfoList.length
              //     ? payableSettlementInfoList[i]?.rate
              //     : null,
              // 第二个节点
              // paymentDate:
              //   paymentInfoList && i <= paymentInfoList.length
              //     ? paymentInfoList[i]?.paymentDate
              //     : null,
              // paymentAmount:
              //   paymentInfoList && i <= paymentInfoList.length
              //     ? paymentInfoList[i]?.paymentAmount
              //     : null,
              // 第三个节点
              invoiceDate:
                payableInvoiceInfoList && i < payableInvoiceInfoList.length
                  ? payableInvoiceInfoList[i]?.invoiceDate
                  : null,
              invoiceQuantity:
                payableInvoiceInfoList && i < payableInvoiceInfoList.length
                  ? payableInvoiceInfoList[i]?.invoiceQuantity
                  : null,
              invoicedAmount:
                payableInvoiceInfoList && i < payableInvoiceInfoList.length
                  ? payableInvoiceInfoList[i]?.invoiceAmount
                  : null,
            };
            // if (!obj.settlementType && paymentInfoList[i]?.settlementType) {
            //   obj.settlementType = paymentInfoList[i]?.settlementType;
            // }
            if (
              payableSettlementInfoList?.length &&
              i < payableSettlementInfoList.length &&
              payableSettlementInfoList[i].rateList?.length
            ) {
              for (let j = 0; j < payableSettlementInfoList[i].rateList.length; j++) {
                const paymentItem = payableSettlementInfoList[i].rateList[j];
                if (paymentItem.ratePaymentList && paymentItem.ratePaymentList.length) {
                  for (let k = 0; k < paymentItem.ratePaymentList.length; k++) {
                    const payItem = paymentItem.ratePaymentList[k];
                    if (k == 0) {
                      // tableData.push({ ...item, ...paymentItem, ...payItem, ...obj });
                      // 当rateList有多条数据时，除第一条数据外，其他数据的上一层只取批次号
                      if (j == 0) {
                        tableData.push({ ...item, ...paymentItem, ...payItem, ...obj });
                      } else {
                        tableData.push({ ...item, ...paymentItem, ...payItem });
                      }
                    } else {
                      tableData.push({ ...item, ...payItem });
                    }
                  }
                } else {
                  if (j == 0) {
                    tableData.push({ ...item, ...paymentItem, ...obj });
                  } else {
                    tableData.push({ ...item, ...paymentItem });
                  }
                }
              }
            } else {
              console.log('111', item, obj);
              tableData.push({ ...item, ...obj });
            }
            console.log(obj, '最后');
          }
        } else {
          tableData.push({ ...item });
        }
        return tableData;
      },
      formatTableData2(item) {
        const tableData = [];
        const receivableSettlementInfoList = item.receivableSettlementInfoList;
        const collectionInfoList = item.collectionInfoList;
        const salesInvoiceInfoList = item.salesInvoiceInfoList;
        const len1 = receivableSettlementInfoList?.length
          ? receivableSettlementInfoList?.length
          : 0;
        const len2 = collectionInfoList?.length ? collectionInfoList?.length : 0;
        const len3 = salesInvoiceInfoList?.length ? salesInvoiceInfoList?.length : 0;
        console.log(len1, len2, len3);
        const max = Math.max(len1, len2, len3);
        if (max > 0) {
          for (let i = 0; i < max; i++) {
            const obj = {
              contractNo:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.contractNo
                  : null,
              settlementNo:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.settlementNo
                  : null,
              periodRange:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.periodRange
                  : null,
              settlementDate:
                receivableSettlementInfoList && i <= receivableSettlementInfoList.length
                  ? receivableSettlementInfoList[i]?.settlementDate
                  : null,
              settlementType:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.settlementType
                  : null,
              settlementQuantity:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.settlementQuantity
                  : null,
              settlementAmount:
                i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.settlementAmount
                  : null,
              preSettlementQuantity:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.preSettlementQuantity
                  : null,
              preSettlementAmount:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.preSettlementAmount
                  : null,
              finalSettlementQuantity:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.finalSettlementQuantity
                  : null,
              finalSettlementAmount:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.finalSettlementAmount
                  : null,
              paymentApplyRequestAmount:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.rateAmount
                  : null,
              paymentApplyRate:
                receivableSettlementInfoList && i <= receivableSettlementInfoList?.length
                  ? receivableSettlementInfoList[i]?.rate
                  : null,
              // 第二个节点
              // contractNo:
              //   collectionInfoList && i <= collectionInfoList?.length
              //     ? collectionInfoList[i]?.contractNo
              //     : null,
              receiveDate:
                collectionInfoList && i <= collectionInfoList?.length
                  ? collectionInfoList[i]?.receiveDate
                  : null,
              receiveAmount:
                collectionInfoList && i <= collectionInfoList?.length
                  ? collectionInfoList[i]?.receiveAmount
                  : null,
              // 第三个节点
              invoiceDate:
                salesInvoiceInfoList && i <= salesInvoiceInfoList?.length
                  ? salesInvoiceInfoList[i]?.invoiceDate
                  : null,
              invoiceQuantity:
                salesInvoiceInfoList && i <= salesInvoiceInfoList?.length
                  ? salesInvoiceInfoList[i]?.invoiceQuantity
                  : null,
              invoicedAmount:
                salesInvoiceInfoList && i <= salesInvoiceInfoList?.length
                  ? salesInvoiceInfoList[i]?.invoiceAmount
                  : null,
            };
            console.log(obj, '最后');
            tableData.push({ ...item, ...obj });
          }
        } else {
          tableData.push({ ...item });
        }
        return tableData;
      },
      async initTableData() {
        if (!this.query.projectInitiationNo) {
          this.$message.error('请选择项目');
          return;
        }
        let params = {
          pageSize: 10,
          pageNum: 1,
          ...this.query,
        };
        if (params.saleContractNoList && !params.saleContractNoList.length) {
          delete params.saleContractNoList;
        }
        if (params.purchaseContractNoList && !params.purchaseContractNoList.length) {
          delete params.purchaseContractNoList;
        }
        const {
          data: { code, data },
        } = await this.$axios.post('/financial/statistic/businessDetail/pageV2', params);
        if (code != 0) {
          this.$message.error('获取数据失败');
          return;
        }
        const { total, list } = data;
        console.log(data, '搜索结果', list, total);
        let tableData1 = [];
        let tableData2 = [];
        for (const item of list) {
          if (item.contractCategory == 'purchase') {
            // 采购的时候
            tableData1.push(this.formatTableData1(item));
          } else {
            // 获取list中里面最长的一个节点
            tableData2.push(this.formatTableData2(item));
          }
        }
        console.log(tableData1, '最后的数据');
        this.tableData1 = tableData1;
        this.tableData2 = tableData2;
      },
      resetProject() {
        if (!this.companyCode) {
          this.departmentCode = null;
        }
        this.query.projectInitiationNo = null;
        this.query.projectName = null;
      },
      getDepartment(companyCode) {
        this.departmentCode = null;
        this.resetProject();
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        };
        this.$axios.post(API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .business-statement {
    ::v-deep {
      .vxe-table--empty-placeholder {
        top: 130px !important;
      }
    }
  }
  .form {
    background: #fff;
    padding: 16px;
    border-radius: 5px;
    margin-bottom: 30px;
  }
</style>
